import { ref, computed, reactive } from "vue";
import dashboardApi from "../api";

export default function (type, chartType = "donut") {
  const data = reactive({
    series: [],
    options: {
      dataLabels: {
        enabled: false
      },
      chart: {
        fontFamily: "Source Sans Pro, Arial, sans-serif",
        type: chartType,
      },
      labels: [],
      colors: ["#5B9BD5", "#4472C4", "#FFC000", "#A5A5A5", "#ED7D31"],
      legend: {
        show: true,
        showForSingleSeries: true,
        position: "right",
        horizontalAlign: "right",
        verticalAlign: "center",
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          formatter: (v) => v + ' чел.',
        },
      },
    },
  });
  const total = ref(0);
  const loadReport = async () => {
    const res = await dashboardApi.getRASReport({ type });
    total.value = 0;
    total.value = res.data.reduce(
      (acc, curr) => (acc += curr.count),
      total.value
    );
    Object.assign(data, {
      ...data,
      series: res.data.map((item) => item.count),
      options: {
        ...data.options,
        labels: res.data.map((item) => item.text),
      },
    });
  };
  loadReport();
  return {
    data: computed(() => data),
    loadReport,
    total: computed(() => total),
  };
}
